module.exports = __webpack_public_path__ + "static/media/Patient_Evaluation_home.b0b371c0.png";